import React, { useReducer } from 'react';
import ToastContext from './ToastContext';
import { v4 as uuid } from 'uuid';
import Alerts from '../component/common/alerts';

const toastReducer = (state, action) => {
  if (action.type === 'ADD_ALERT') {
    const updatedAlerts = state.alerts.concat({
      id: action.alert.id,
      text: action.alert.text,
      class: action.category,
    });

    return {
      ...state,
      alerts: updatedAlerts,
    };
  }
  if (action.type === 'REMOVE_ALERT') {
    const updatedAlerts = state.alerts.filter(
      (alert) => alert.id !== action.id,
    );
    return {
      ...state,
      alerts: updatedAlerts,
    };
  }
};
const ToastProvider = (props) => {
  const defaultToastState = {
    alerts: [],
    floatingTime: props.AutoClose ? props.AutoClose : 5000,
    position: props.position ? props.position : 'top-right',
    direction: props.direction,
  };

  const [toastState, dispatchToastAction] = useReducer(
    toastReducer,
    defaultToastState,
  );

  const addAlert = (alert, category = '') => {
    dispatchToastAction({
      type: 'ADD_ALERT',
      alert: alert,
      category: category,
    });
    setTimeout(function () {
      removeAlert(alert.id);
    }, toastState.floatingTime);
  };

  const removeAlert = (id) => {
    dispatchToastAction({ type: 'REMOVE_ALERT', id: id });
  };

  const alertContext = {
    alerts: toastState.alerts,
    direction: toastState.direction,
    position: toastState.position,
    floatingTime: toastState.floatingTime,
    error: (message) => addAlert({ id: uuid(), text: message }, 'error'),
    success: (message) => addAlert({ id: uuid(), text: message }, 'success'),
    info: (message) => addAlert({ id: uuid(), text: message }, 'info'),
    warning: (message) => addAlert({ id: uuid(), text: message }, 'warning'),
    removeAlert: removeAlert,
  };

  return (
    <ToastContext.Provider value={alertContext}>
      {props.children}
      <Alerts />
    </ToastContext.Provider>
  );
};

export default ToastProvider;
